import { render } from "./AddCategoryView.vue?vue&type=template&id=640e12b7"
import script from "./AddCategoryView.vue?vue&type=script&lang=js"
export * from "./AddCategoryView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\WORK\\Tamani\\admin-landing\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__